/* eslint-disable react/no-danger */
/**
 * Minimal head for Flight Status page (MMT only).
 * Adds base styles so header/footer and layout match other flight pages.
 */
import { getFontUrl } from "../../utils/helper/utils";
import { bankOfferCSS } from "../../utils/stylesUtil/bankOffer";
import { baseMinCss } from "../../utils/stylesUtil/baseMin";
import { flightInlinceCss } from "../../utils/stylesUtil/flightsInline";
import { footerCSS } from "../../utils/stylesUtil/footer";
import { jqueryUIMinCss } from "../../utils/stylesUtil/jqueryUIMin";
import { seoBaseMin } from "../../utils/stylesUtil/seoBase";
import { topOverlayCSS } from "../../utils/stylesUtil/topOverlay";

export const appendHeadFlightStatus = (props) => {
  const { appConfig = {}, language, isGoibibo = false, tokenJson } = props || {};
  let cssPath = "http://localhost:3000/_next/static/css";
  if (appConfig?.liveMode) {
    cssPath = "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/css";
  }
  const seoListingPath = `${cssPath}/seoListing.min.css`;
  const tokenJsonString =
    tokenJson && Object.keys(tokenJson).length !== 0
      ? `var tokenJson = ${JSON.stringify(tokenJson)};`
      : "var tokenJson = {};";

  return (
    <>
      <link rel="preconnect" href="//jsak.mmtcdn.com" crossOrigin />
      <link rel="preconnect" href="//cssak.mmtcdn.com" crossOrigin />
      <link rel="preconnect" href="//imgak.mmtcdn.com" crossOrigin />
      <link href={`${cssPath}/bootstrap.min.css`} rel="stylesheet" />
      {isGoibibo ? (
        <link href={`${cssPath}/dweb-header.min.css`} rel="stylesheet" />
      ) : (
        <link href={`${cssPath}/header.min.css`} rel="stylesheet" />
      )}
      <style dangerouslySetInnerHTML={{ __html: seoBaseMin }} />
      <style dangerouslySetInnerHTML={{ __html: jqueryUIMinCss }} />
      <style dangerouslySetInnerHTML={{ __html: bankOfferCSS }} />
      <style dangerouslySetInnerHTML={{ __html: topOverlayCSS }} />
      <style dangerouslySetInnerHTML={{ __html: baseMinCss }} />
      <style dangerouslySetInnerHTML={{ __html: flightInlinceCss }} />
      <link href={`${cssPath}/flightNewIndexLanding.min.css`} rel="stylesheet" />
      <link href={`${cssPath}/baseFlightStatus.min.css`} rel="stylesheet" />
      <link href={`${cssPath}/flight-status.min.css`} rel="stylesheet" />
      <link href={seoListingPath} rel="stylesheet" />
      <script type="text/javascript" dangerouslySetInnerHTML={{ __html: tokenJsonString }} />
      <style dangerouslySetInnerHTML={{ __html: footerCSS }} />
      <link
        rel="stylesheet"
        href={getFontUrl(language, isGoibibo)}
        as="style"
        onLoad="this.onload=null;this.rel='stylesheet'"
      />
    </>
  );
};
